import React, { useRef, useEffect } from "react";

const GallerySection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("active");
          } else {
            e.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.2 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  return (
    <section className="hp-gallery-section hp-section hp-reveal" ref={sectionRef}>
      <div className="hp-gallery-inner">
        <h2
          className="text-2xl font-bold text-center uppercase mb-8 hp-products-heading"
          style={{ color: "var(--kuku-dark)" }}
        >
          Choose your favorites
        </h2>
        <div className="hp-gallery-gif-wrap">
          <img
            className="hp-gallery-gif"
            src="/kuku-assets/images/new-launch.gif"
            alt="New launch"
          />
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
